import React, { Component } from 'react'
import { Progress } from 'semantic-ui-react'

export default class ProgressBar extends Component {
  render() {
    return (
      <div style = {{width: "500px", margin: "0 auto"}}>
        <Progress percent={this.props.percent} indicating progress className = "progressCustom" size = "small"/>
      </div>
    )
  }
}